import { FC } from "react";

const Null: FC = () => null;

Null.displayName = "Null";

export default Null;
